<template>
  <div class="all" style="width:940px">
    <!-- <div  @click="todoExport"> 导出</div> -->
    <!-- <div  @click="todoPrintS"> 打印</div> -->
    <div id="table">
      <table border="1" cellpadding="0" cellspacing="0" style="width:100%">
        <thead>
          <tr>
            <th v-for="(item,index) in nameTitle" :key="index" @click="handleSort(item.key)"
              style="position:sticky;top:-24px;background-color:#fff;">{{item.name}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(tr,i) in list" :key="tr.code">
            <td align="center">{{i+1}}</td>
            <td align="center">{{tr.orderNum}}</td>
            <td align="center">{{tr.restaurant}}</td>
            <td align="center">{{tr.mealTableNum}}</td>
            <td align="center">{{tr.mealTableName}}</td>
            <td align="center">{{tr.businessDate}}</td>

            <td align="center">
              {{tr.shiftCode == 1 ? '早班'  : tr.shiftCode == 2 ? '中班'  : tr.shiftCode == 3 ? '晚班'  : tr.shiftCode == 4 ? '夜班'  : '未知'}}
            </td>
            <td align="center">{{tr.userName}}</td>
            <td align="center">{{tr.peopleCount}}</td>
            <td align="center">￥{{tr.allPrice.toFixed(2)}}</td>
            <td align="center">{{tr.checkType}}</td>
            <td align="center">{{tr.status}}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td align="center"> 合计 </td>
            <td align="center"> 餐单数： </td>
            <td align="center"> {{allNum}} </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <!-- <td></td> -->

            <!-- <td align="center"> 人数： </td> -->
            <td align="center"> {{People}}</td>
            <!-- <td align="center"> 总金额： </td> -->
            <td align="center">￥{{allPrice ? allPrice.toFixed(2) : 0}} </td>
            <td></td>

            <td></td>

          </tr>

        </tfoot>
      </table>

    </div>

  </div>
</template>
<script>
  import getLodop from '../../utils/Lodopfuncs'

  export default {
    props: {
      tabelList: {
        type: Array,
        default: []
      },
      allNum: {
        type: Number,
        default: 0
      },
      allPrice: {
        type: Number,
        default: 0
      },
      allPeople: {
        type: Number,
        default: 0
      },

    },
    data() {
      return {
        printnameB: "清餐热菜",
        nameTitle: [{
          name: '序号',
          key: 'index'
        }, {
          name: '单号',
          key: 'room'
        }, {
          name: '营业点',
          key: 'room_num'
        }, {
          name: '桌号',
          key: 'room_num'
        }, {
          name: '桌号描述',
          key: 'room_num'
        }, {
          name: '营业日期',
          key: 'room_num'
        }, {
          name: '班次',
          key: 'room_num'
        }, {
          name: '工号',
          key: 'room_num'
        }, {
          name: '人数',
          key: 'room_num'
        }, {
          name: '金额',
          key: 'room_num'
        }, {
          name: '付款方式',
          key: 'room_num'
        }, {
          name: '状态',
          key: 'room_num'
        }, ],
        tableList: [],
        printlists: [],
        type: "",
        remark: undefined,
        printnumber: 0,
        stampumber: 0,

      }
    },
    watch: {


    },
    computed: {
      list() {
        return this.tabelList
      },
      People() {
        let num=0
        this.tabelList.map(res => {
          num += res.peopleCount*1
        })

        return num

      }

    },
    mounted() {
      this.$bus.$on('printName', val => {
        this.printnameB = val
      })
      this.$bus.$on('excel', val => {
        this.todoExport()
      })
      this.$bus.$on('printtable', val => {
        this.printnameB = val
        this.todoPrintS()
        // console.log(1111,this.printnameB);
      })
    },
    created() {
      this.getTime()


    },
    methods: {


      getTime() {

        let date = new Date();
        let y = 1900 + date.getYear();
        let m = "0" + (date.getMonth() + 1);
        let d = "0" + date.getDate();
        let h = "0" + date.getHours();
        let mm = "0" + date.getMinutes();
        let s = date.getSeconds();
        this.time = y + "-" + m.substring(m.length - 2, m.length) + "-" + d.substring(d.length - 2, d.length) + " " + h
          .substring(h.length - 2, h.length) + ":" + mm.substring(mm.length - 2, mm.length);



      },


      GetPrinter() {
        //获取当前打印机

        LODOP = getLodop();

        var iCount = LODOP.GET_PRINTER_COUNT();

        var PData = [];

        for (var i = 0; i < iCount; i++) {
          PData.push(LODOP.GET_PRINTER_NAME(i));
        }

        return PData;
      },

      getPrint() {
        // console.log('打印任务');
        // this.getCurrentTime()
        // this.printnameB = localStorage.getItem('printName')
        if (this.orderObj.code) {

          this.$nextTick(() => {
            // console.log(this.printnameB, this.orderObj);

            this.todoPrintS()
          })
        } else {
          setTimeout(() => {
            this.todoPrintS()
          }, 1000);
        }

      },
      todoPrintS() {

        // this.printlists = [...list]
        // this.name = name
        const LODOP = getLodop()
        if (LODOP) {

          //获取打印内容
          var strFormHtml = `<body>` + document.getElementById('table').innerHTML + '</body>' //获取打印内容
          console.log(this.printnameB);
          LODOP.PRINT_INIT('') //初始化
          LODOP.SET_PRINT_PAGESIZE(1, 60, 0, '') //设置纵向
          // LODOP.SET_PRINT_PAGESIZE(1, 0, 0, 'A4')  //设置纵向
          LODOP.ADD_PRINT_HTM('5', '20', '90%', '80%', strFormHtml)
          // LODOP.SET_PRINT_STYLEA(0, "Offset2Top", 10)
          // LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", 0)
          // LODOP.SET_PRINT_STYLEA(0, "TextNeatRow", true)
          LODOP.SET_PREVIEW_WINDOW(2, 0, 0, 800, 800, '') //设置预览窗口模式和大小
          LODOP.SET_PRINT_MODE("NOCLEAR_AFTER_PRINT", true); //设置打印完毕不清理打印信息
          var PData = this.GetPrinter();
          LODOP.SET_PRINTER_INDEXA(this.printnameB); //设置某个打印机
          LODOP.PRINT()
        }
      },
      todoExport() {
        var LODOP = getLodop();
        LODOP.PRINT_INIT("");
        LODOP.ADD_PRINT_TABLE(5, 5, "99%", "100%", document.getElementById("table").innerHTML);
        //LODOP.SET_SAVE_MODE("QUICK_SAVE",true);//快速生成（无表格样式,数据量较大时或许用到）
        LODOP.SAVE_TO_FILE("新文件名.xls");
      }

    }

  }
</script>
<style lang="scss" scoped>
  #tablePrint {
    padding: 10px 15px;
    font-size: 12px;
    text-align: left;
  }

  .shopName {
    text-align: center;
  }

  .boxName {
    text-align: center;
  }

  .label {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .btn {
    width: 100%;
    display: flex;
    justify-content: space-between;

    /deep/ .el-button {
      width: 160px;
    }
  }
</style>